import {Box,Button,Container,FormControl,Grid,InputLabel,MenuItem,Paper,Select,Table,Alert,TableBody,TableCell,TableContainer,Backdrop,CircularProgress,TableHead,TableRow,TextField,Snackbar,styled,Checkbox,FormGroup,FormControlLabel,Switch,} from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import Modal from "../modal/Modal";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../Constants";
import ArrowUpward from "@mui/icons-material/ArrowUpward";
import ArrowBottom from "@mui/icons-material/ArrowDownward";
import { axiosClient } from "../AxiosClient";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const ButtonPrincipal = styled(Button)({
  flexGrow: 0,
  borderRadius: "20px",
  gap: "10px",
  color: "#FFFFFF",
  backgroundColor: "#161e55",
  "&:hover": {
    backgroundColor: "#A8C8AF",
  },
});

const versions = ["V1", "V2"];
const settings = ["Y", "O"];
const urlApi = API_URL;
const tasasInteres = ["Tasa de interés de consumo","Tasa de interés de consumo de bajo monto",];
const tarifasfga = [
  {
    name: "10%",
    value: 0.1,
  },
  {
    name: "15%",
    value: 0.15,
  },
  {
    name: "20%",
    value: 0.2,
  },
  {
    name: "25%",
    value: 0.25,
  },
  {
    name: "30%",
    value: 0.3,
  },
];
const tiposCreditos = ["Reales", "Telco", "Financieros"];

const FPD_FIELDS_V1 = [
  "scoreMaximoFpdIngresoNoValidado",
  "scoreMaximoFpdIngresoValidado",
];

const SCORE_MINIMO_PAGAR_FIELDS_V2 = [
  "scoreMinimoPagarFpdIngresoNoValidado",
  "scoreMinimoPagarFpdIngresoValidado",
  "scoreMinimoPagarScorePramiIngresoNoValidado",
  "scoreMinimoPagarScorePramiIngresoValidado",
];

const ALL_SCORE_RANGE_FIELDS = [
  ...FPD_FIELDS_V1,
  ...SCORE_MINIMO_PAGAR_FIELDS_V2,
];

const EMPTY_SCORE_MINIMO_PAGAR = {
  scoreMinimoPagarFpdIngresoNoValidado: null,
  scoreMinimoPagarFpdIngresoValidado: null,
  scoreMinimoPagarScorePramiIngresoNoValidado: null,
  scoreMinimoPagarScorePramiIngresoValidado: null,
};

const getScoreRangeFields = (policyVersion) =>
  policyVersion === "V2" ? SCORE_MINIMO_PAGAR_FIELDS_V2 : FPD_FIELDS_V1;

const normalizeFpdValue = (value) => {
  if (value == null) {
    return "";
  }

  return String(value).trim().replace(",", ".");
};

const getFpdValidationMessage = (value) => {
  const normalizedValue = normalizeFpdValue(value);

  if (normalizedValue === "") {
    return "Este campo es requerido";
  }

  if (!/^-?\d+(?:\.\d+)?$/.test(normalizedValue)) {
    return "Debe ingresar un valor numérico";
  }

  const numericValue = Number(normalizedValue);
  if (numericValue < 0 || numericValue > 1) {
    return "El valor debe estar entre 0 y 1";
  }

  return "";
};

const getFpdValidationErrors = (ticket, policyVersion = "V1") =>
  getScoreRangeFields(policyVersion).reduce((errors, field) => {
    const message = getFpdValidationMessage(ticket?.[field]);
    if (message) {
      errors[field] = message;
    }
    return errors;
  }, {});

const normalizeTicketFpdValues = (ticket, policyVersion = "V1") => {
  const normalizedTicket = { ...ticket };
  getScoreRangeFields(policyVersion).forEach((field) => {
    normalizedTicket[field] = normalizeFpdValue(ticket?.[field]);
  });
  return normalizedTicket;
};

const buildTicketScorePayload = (items, policyVersion) => {
  if (policyVersion === "V2") {
    return {
      scoreIngresosNoValidados: items.scoreIngresosNoValidados,
      scoreIngresosValidados: items.scoreIngresosValidados,
      scoreMaximoFpdIngresoNoValidado: 0,
      scoreMaximoFpdIngresoValidado: 0,
      scoreMinimoPagarFpdIngresoNoValidado: Number(
        normalizeFpdValue(items.scoreMinimoPagarFpdIngresoNoValidado),
      ),
      scoreMinimoPagarFpdIngresoValidado: Number(
        normalizeFpdValue(items.scoreMinimoPagarFpdIngresoValidado),
      ),
      scoreMinimoPagarScorePramiIngresoNoValidado: Number(
        normalizeFpdValue(items.scoreMinimoPagarScorePramiIngresoNoValidado),
      ),
      scoreMinimoPagarScorePramiIngresoValidado: Number(
        normalizeFpdValue(items.scoreMinimoPagarScorePramiIngresoValidado),
      ),
    };
  }

  return {
    scoreIngresosNoValidados: items.scoreIngresosNoValidados,
    scoreMaximoFpdIngresoNoValidado: Number(
      normalizeFpdValue(items.scoreMaximoFpdIngresoNoValidado),
    ),
    scoreIngresosValidados: items.scoreIngresosValidados,
    scoreMaximoFpdIngresoValidado: Number(
      normalizeFpdValue(items.scoreMaximoFpdIngresoValidado),
    ),
  };
};

export default function Policy() {
  const [values, setValues] = useState([
    {
      id: 1,
      scoreMinimo: null,
      scoreMaximo: null,
      percentage: null,
    },
  ]);
  const [tickets, setTickets] = useState([
    {
      id: 1,
      ticketMinimo: null,
      ticketMaximo: null,
      maxCuota: null,
      creditosRealesIngresosNoValidados: null,
      creditosTelcoIngresosNoValidados: null,
      creditosFinancierosIngresosNoValidados: null,
      creditosRealesTelcoIngresosNoValidados: null,
      scoreIngresosNoValidados: null,
      scoreMaximoFpdIngresoNoValidado: null,
      porcentajeUtilizacionIngresosNoValidados: null,
      creditosRealesIngresosValidados: null,
      creditosTelcoIngresosValidados: null,
      creditosFinancierosIngresosValidados: null,
      creditosRealesTelcoIngresosValidados: null,
      scoreIngresosValidados: null,
      scoreMaximoFpdIngresoValidado: null,
      ...EMPTY_SCORE_MINIMO_PAGAR,
      porcentajeUtilizacionIngresosValidados: null,
      settingsNoValidados: {
        realTelco: "O",
        realFinanciero: "O",
        financieroTelco: "O",
      },
      settingsValidados: {
        realTelco: "O",
        realFinanciero: "O",
        financieroTelco: "O",
      },
      valueStructuresNoValidados: [
        {
          id: 1,
          creditosReales: true,
          creditosTelco: true,
          creditosFinancieros: true,
        },
      ],
      valueStructuresValidados: [
        {
          id: 1,
          creditosReales: true,
          creditosTelco: true,
          creditosFinancieros: true,
        },
      ],
    },
  ]);
  const [version, setVersion] = useState("V1");
  const [policies, setPolicies] = useState([]);
  const [isTicket, setIsTicket] = useState(false);
  const [indexTicket, setIndexTicket] = useState();
  const [ticketUpdate, setTicketUpdate] = useState({
    id: tickets[tickets.length - 1].id + 1,
    ticketMinimo: null,
    ticketMaximo: null,
    maxCuota: null,
    creditosRealesIngresosNoValidados: null,
    creditosTelcoIngresosNoValidados: null,
    creditosFinancierosIngresosNoValidados: null,
    creditosRealesTelcoIngresosNoValidados: null,
    scoreIngresosNoValidados: null,
    scoreMaximoFpdIngresoNoValidado: null,
    porcentajeUtilizacionIngresosNoValidados: null,
    creditosRealesIngresosValidados: null,
    creditosTelcoIngresosValidados: null,
    creditosFinancierosIngresosValidados: null,
    creditosRealesTelcoIngresosValidados: null,
    scoreIngresosValidados: null,
    scoreMaximoFpdIngresoValidado: null,
      ...EMPTY_SCORE_MINIMO_PAGAR,
    porcentajeUtilizacionIngresosValidados: null,
    settingsNoValidados: {
      realTelco: "O",
      realFinanciero: "O",
      financieroTelco: "O",
    },
    settingsValidados: {
      realTelco: "O",
      realFinanciero: "O",
      financieroTelco: "O",
    },
    valueStructuresNoValidados: [
      {
        id: 1,
        creditosReales: true,
        creditosTelco: true,
        creditosFinancieros: true,
      },
    ],
    valueStructuresValidados: [
      {
        id: 1,
        creditosReales: true,
        creditosTelco: true,
        creditosFinancieros: true,
      },
    ],
  });
  const [policy, setPolicy] = useState();
  const [policyUpdate, setPolicyUpdate] = useState({
    version: null,
    name: "",
    baseGastoPersonal: "",
    gastoDependientes: "",
    porcentajeUtilizacionSobreIngresoBruto: "",
    porcentajeUtilizacionSobreIngresoNeto: "",
    edadMinima: "",
    edadMaxima: "",
  });
  const navigate = useNavigate();
  const [validations, setValidations] = useState({});
  const [valuesSize, setValuesSize] = useState();
  const [verifications, setVerifications] = useState({});
  const [validation, setValidation] = useState({
    politica: {},
    tickets: {},
  });
  const [snackBar, setSnackbar] = useState(false);
  const [backdrop, setBackdrop] = useState(false);
  const [alerta, setAlerta] = useState();
  const [severity, setSeverity] = useState();

  const sumValues = () => {
    setValues([
      ...values,
      {
        id: values[values.length - 1].id + 1,
        scoreMinimo: null,
        scoreMaximo: null,
        percentage: null,
      },
    ]);
    setValidations({});
    setValuesSize(values.length + 1);
  };

  const sumTicket = () => {
    setTickets([
      ...tickets,
      {
        id: tickets[tickets.length - 1].id + 1,
        ticketMinimo: null,
        ticketMaximo: null,
        maxCuota: null,
        creditosRealesIngresosNoValidados: null,
        creditosTelcoIngresosNoValidados: null,
        creditosFinancierosIngresosNoValidados: null,
        creditosRealesTelcoIngresosNoValidados: null,
        scoreIngresosNoValidados: null,
        scoreMaximoFpdIngresoNoValidado: null,
        porcentajeUtilizacionIngresosNoValidados: null,
        creditosRealesIngresosValidados: null,
        creditosTelcoIngresosValidados: null,
        creditosFinancierosIngresosValidados: null,
        creditosRealesTelcoIngresosValidados: null,
        scoreIngresosValidados: null,
        scoreMaximoFpdIngresoValidado: null,
      ...EMPTY_SCORE_MINIMO_PAGAR,
        porcentajeUtilizacionIngresosValidados: null,
        settingsNoValidados: {
          realTelco: "O",
          realFinanciero: "O",
          financieroTelco: "O",
        },
        settingsValidados: {
          realTelco: "O",
          realFinanciero: "O",
          financieroTelco: "O",
        },
        valueStructuresNoValidados: [
          {
            id: 1,
            creditosReales: true,
            creditosTelco: true,
            creditosFinancieros: true,
          },
        ],
        valueStructuresValidados: [
          {
            id: 1,
            creditosReales: true,
            creditosTelco: true,
            creditosFinancieros: true,
          },
        ],
      },
    ]);
  };

  const deletePercentage = (index) => {
    values.splice(index, 1);
    setValues([...values]);
    setValidations({});
    setValuesSize(values.length);
  };

  const updatePercentage = (event, index) => {
    values.splice(index, 1, {
      ...values[index],
      [event.target.name]: event.target.value,
    });
    setValues([...values]);
  };

  const editTicket = (index) => {
    setIsTicket(!isTicket);
    setIndexTicket(index);
    setTicketUpdate(tickets[index]);
    setValidation({ ...validation, tickets: {} });
  };

  const handleSegmentation = () => {
    navigate("/homeAdmin/segmentation");
  };

  const updateFpdValidationErrors = (errors) => {
    setValidation((currentValidation) => {
      const ticketErrors = { ...currentValidation.tickets };
      ALL_SCORE_RANGE_FIELDS.forEach((field) => delete ticketErrors[field]);

      return {
        ...currentValidation,
        tickets: {
          ...ticketErrors,
          ...errors,
        },
      };
    });
  };

  const handleFpdBlur = (event) => {
    const { name, value } = event.target;
    const normalizedValue = normalizeFpdValue(value);
    const message = getFpdValidationMessage(normalizedValue);

    setTicketUpdate((currentTicket) => ({
      ...currentTicket,
      [name]: normalizedValue,
    }));

    setValidation((currentValidation) => {
      const ticketErrors = { ...currentValidation.tickets };
      if (message) {
        ticketErrors[name] = message;
      } else {
        delete ticketErrors[name];
      }

      return { ...currentValidation, tickets: ticketErrors };
    });
  };

  const updateTicket = () => {
    const normalizedTicket = normalizeTicketFpdValues(ticketUpdate, version);
    const fpdErrors = getFpdValidationErrors(normalizedTicket, version);

    updateFpdValidationErrors(fpdErrors);
    if (Object.keys(fpdErrors).length > 0) {
      return;
    }

    setTickets((currentTickets) =>
      currentTickets.map((ticket, index) =>
        index === indexTicket ? normalizedTicket : ticket,
      ),
    );
    setIsTicket(false);
  };

  const deleteTicket = (index) => {
    tickets.splice(index, 1);
    setTickets([...tickets]);
  };

  const handleUpdateTicket = (event) => {
    if (event.target.name?.name == "ingresos-validados") {
      console.log(event.target.value);
      setTicketUpdate({
        ...ticketUpdate,
        settingsValidados: {
          ...ticketUpdate.settingsValidados,
          [event.target.name.value]: event.target.value,
        },
      });
    } else if (event.target.name?.name == "ingresos-no-validados") {
      console.log(event.target.value);
      setTicketUpdate({
        ...ticketUpdate,
        settingsNoValidados: {
          ...ticketUpdate.settingsNoValidados,
          [event.target.name.value]: event.target.value,
        },
      });
    } else {
      setTicketUpdate({
        ...ticketUpdate,
        [event.target.name]: event.target.value,
      });
    }
  };

  const handleVersion = (event) => {
    setVersion(event.target.value);
    setPolicyUpdate({
      version: null,
      name: "",
      baseGastoPersonal: "",
      gastoDependientes: "",
      porcentajeUtilizacionSobreIngresoBruto: "",
      porcentajeUtilizacionSobreIngresoNeto: "",
      edadMinima: "",
      edadMaxima: "",
    });
    setTickets([
      {
        id: tickets[tickets.length - 1].id + 1,
        ticketMinimo: null,
        ticketMaximo: null,
        maxCuota: null,
        creditosRealesIngresosNoValidados: null,
        creditosTelcoIngresosNoValidados: null,
        creditosFinancierosIngresosNoValidados: null,
        creditosRealesTelcoIngresosNoValidados: null,
        scoreIngresosNoValidados: null,
        scoreMaximoFpdIngresoNoValidado: null,
        porcentajeUtilizacionIngresosNoValidados: null,
        creditosRealesIngresosValidados: null,
        creditosTelcoIngresosValidados: null,
        creditosFinancierosIngresosValidados: null,
        creditosRealesTelcoIngresosValidados: null,
        scoreIngresosValidados: null,
        scoreMaximoFpdIngresoValidado: null,
      ...EMPTY_SCORE_MINIMO_PAGAR,
        porcentajeUtilizacionIngresosValidados: null,
        creditosFinancierosAbiertosIngresosNoValidados: null,
        creditosFinancierosAbiertosIngresosValidados: null,
        tarifafgaIngresosNoValidados: null,
        tarifafgaIngresosValidados: null,
        settingsNoValidados: {
          realTelco: "O",
          realFinanciero: "O",
          financieroTelco: "O",
        },
        settingsValidados: {
          realTelco: "O",
          realFinanciero: "O",
          financieroTelco: "O",
        },
        valueStructuresNoValidados: [
          {
            id: 1,
            creditosReales: true,
            creditosTelco: true,
            creditosFinancieros: true,
          },
        ],
        valueStructuresValidados: [
          {
            id: 1,
            creditosReales: true,
            creditosTelco: true,
            creditosFinancieros: true,
          },
        ],
      },
    ]);
    setTicketUpdate({
      id: tickets[tickets.length - 1].id + 1,
      ticketMinimo: null,
      ticketMaximo: null,
      maxCuota: null,
      creditosRealesIngresosNoValidados: null,
      creditosTelcoIngresosNoValidados: null,
      creditosFinancierosIngresosNoValidados: null,
      creditosRealesTelcoIngresosNoValidados: null,
      scoreIngresosNoValidados: null,
      scoreMaximoFpdIngresoNoValidado: null,
      porcentajeUtilizacionIngresosNoValidados: null,
      creditosRealesIngresosValidados: null,
      creditosTelcoIngresosValidados: null,
      creditosFinancierosIngresosValidados: null,
      creditosRealesTelcoIngresosValidados: null,
      scoreIngresosValidados: null,
      scoreMaximoFpdIngresoValidado: null,
      ...EMPTY_SCORE_MINIMO_PAGAR,
      porcentajeUtilizacionIngresosValidados: null,
      tarifafgaIngresosNoValidados: null,
      tarifafgaIngresosValidados: null,
      settingsNoValidados: {
        realTelco: "O",
        realFinanciero: "O",
        financieroTelco: "O",
      },
      settingsValidados: {
        realTelco: "O",
        realFinanciero: "O",
        financieroTelco: "O",
      },
      valueStructuresNoValidados: [
        {
          id: 1,
          creditosReales: true,
          creditosTelco: true,
          creditosFinancieros: true,
        },
      ],
      valueStructuresValidados: [
        {
          id: 1,
          creditosReales: true,
          creditosTelco: true,
          creditosFinancieros: true,
        },
      ],
    });
    setPolicy([]);
    setPolicyUpdate({
      version: null,
      name: "",
      baseGastoPersonal: "",
      gastoDependientes: "",
      porcentajeUtilizacionSobreIngresoBruto: "",
      porcentajeUtilizacionSobreIngresoNeto: "",
      edadMinima: "",
      edadMaxima: "",
    });
    setValues([
      {
        id: 1,
        scoreMinimo: null,
        scoreMaximo: null,
        percentage: null,
      },
    ]);
  };

  const handleSnackbar = () => {
    setSnackbar(false);
  };

  const handlePolicy = (event) => {
    setPolicy(event.target.value);
    setPolicyUpdate(event.target.value?.policy);
    if (event.target.value?.valueSegmentations.length > 0) {
      console.log(event.target.value?.policy);
      setTickets(
        event.target.value?.valueSegmentations
          .sort((a, b) => Number(a.ticketMinimo) - Number(b.ticketMinimo))
          .map((items, index) => ({
            ...items,
            id: index,
            scoreMaximoFpdIngresoNoValidado: normalizeFpdValue(
              items.scoreMaximoFpdIngresoNoValidado,
            ),
            scoreMaximoFpdIngresoValidado: normalizeFpdValue(
              items.scoreMaximoFpdIngresoValidado,
            ),
            scoreMinimoPagarFpdIngresoNoValidado: normalizeFpdValue(
              items.scoreMinimoPagarFpdIngresoNoValidado,
            ),
            scoreMinimoPagarFpdIngresoValidado: normalizeFpdValue(
              items.scoreMinimoPagarFpdIngresoValidado,
            ),
            scoreMinimoPagarScorePramiIngresoNoValidado: normalizeFpdValue(
              items.scoreMinimoPagarScorePramiIngresoNoValidado,
            ),
            scoreMinimoPagarScorePramiIngresoValidado: normalizeFpdValue(
              items.scoreMinimoPagarScorePramiIngresoValidado,
            ),
            tarifafgaIngresosNoValidados: items.tarifafgaIngresosNoValidados,
            tarifafgaIngresosValidados: items.tarifafgaIngresosValidados,
            settingsNoValidados: {
              realTelco: items.valueSetting.realTelcoIngresosNoValidados,
              realFinanciero:
                items.valueSetting.realFinancieroIngresosNoValidados,
              financieroTelco:
                items.valueSetting.telcoFinancieroIngresosNoValidados,
            },
            settingsValidados: {
              realTelco: items.valueSetting.realTelcoIngresosValidados,
              realFinanciero:
                items.valueSetting.realFinancieroIngresosValidados,
              financieroTelco:
                items.valueSetting.telcoFinancieroIngresosValidados,
            },
            valueStructuresNoValidados:
              items.valueStructures?.length > 0
                ? items.valueStructures
                    .filter((items) => !items.esIngresoValidado)
                    .map((item) => ({
                      id: index,
                      creditosReales: item.creditosReales,
                      creditosTelco: item.creditosTelco,
                      creditosFinancieros: item.creditosFinancieros,
                    }))
                : [
                    {
                      id: 1,
                      creditosReales: true,
                      creditosTelco: true,
                      creditosFinancieros: true,
                    },
                  ],
            valueStructuresValidados:
              items.valueStructures?.length > 0
                ? items.valueStructures
                    .filter((items) => items.esIngresoValidado)
                    .map((item) => ({
                      id: index,
                      creditosReales: item.creditosReales,
                      creditosTelco: item.creditosTelco,
                      creditosFinancieros: item.creditosFinancieros,
                    }))
                : [
                    {
                      id: 1,
                      creditosReales: true,
                      creditosTelco: true,
                      creditosFinancieros: true,
                    },
                  ],
          })),
      );
    } else {
      setTickets([
        {
          id: 1,
          ticketMinimo: null,
          ticketMaximo: null,
          maxCuota: null,
          creditosRealesIngresosNoValidados: null,
          creditosTelcoIngresosNoValidados: null,
          creditosFinancierosIngresosNoValidados: null,
          creditosRealesTelcoIngresosNoValidados: null,
          scoreIngresosNoValidados: null,
          scoreMaximoFpdIngresoNoValidado: null,
          porcentajeUtilizacionIngresosNoValidados: null,
          creditosRealesIngresosValidados: null,
          creditosTelcoIngresosValidados: null,
          creditosFinancierosIngresosValidados: null,
          creditosRealesTelcoIngresosValidados: null,
          scoreIngresosValidados: null,
          scoreMaximoFpdIngresoValidado: null,
      ...EMPTY_SCORE_MINIMO_PAGAR,
          porcentajeUtilizacionIngresosValidados: null,
          settingsNoValidados: {
            realTelco: "O",
            realFinanciero: "O",
            financieroTelco: "O",
          },
          settingsValidados: {
            realTelco: "O",
            realFinanciero: "O",
            financieroTelco: "O",
          },
          valueStructuresNoValidados: [
            {
              id: 1,
              creditosReales: true,
              creditosTelco: true,
              creditosFinancieros: true,
            },
          ],
          valueStructuresValidados: [
            {
              id: 1,
              creditosReales: true,
              creditosTelco: true,
              creditosFinancieros: true,
            },
          ],
        },
      ]);
    }
    if (event.target.value?.intervalPolicies.length > 0) {
      setValues(
        event.target.value?.intervalPolicies.map((items, index) => ({
          id: index + 1,
          scoreMinimo: items?.scoreMinimo,
          scoreMaximo: items?.scoreMaximo,
          percentage: items?.percentage,
        })),
      );
    } else {
      setValues([
        {
          id: 1,
          scoreMinimo: null,
          scoreMaximo: null,
          percentage: null,
        },
      ]);
    }
  };

  console.log(tickets);

  const handleUpdate = (event) => {
    setPolicyUpdate({
      ...policyUpdate,
      [event.target.name]: event.target.value,
    });
  };

  const validateIntervals = () => {
    const validation = {};
    values.forEach((items, index) => {
      if (validation[index]) {
        validation[index].texts = "";
      }
      if (isNaN(items.scoreMinimo)) {
        validation[index] = {
          texts: "Los campos deben tener valores numéricos",
          scoreMinimo: true,
          scoreMaximo: false,
          percentage: false,
        };
      }
      if (isNaN(items.scoreMaximo)) {
        if (validation[index]) {
          validation[index].texts = "Los campos deben tener valores numéricos";
          validation[index].scoreMaximo = true;
        } else {
          validation[index] = {
            texts: "Los campos deben tener valores numéricos",
            scoreMinimo: false,
            scoreMaximo: true,
            percentage: false,
          };
        }
      }
      if (isNaN(items.percentage)) {
        if (validation[index]) {
          validation[index].texts = "Los campos deben tener valores numéricos";
          validation[index].percentage = true;
        } else {
          validation[index] = {
            texts: "Los campos deben tener valores numéricos",
            scoreMinimo: false,
            scoreMaximo: false,
            percentage: true,
          };
        }
      }
      if (parseInt(items.scoreMinimo) > parseInt(items.scoreMaximo)) {
        if (validation[index]) {
          validation[index].texts +=
            " El score mínimo no debe ser mayor al score máximo";
          validation[index].scoreMinimo = true;
          validation[index].scoreMaximo = true;
        } else {
          validation[index] = {
            texts: "El score mínimo no debe ser mayor al score máximo",
            scoreMinimo: true,
            scoreMaximo: true,
            percentage: false,
          };
        }
      }
      if (parseInt(items.scoreMinimo) < 0) {
        if (validation[index]) {
          validation[index].texts += " El score mínimo no debe ser negativo";
          validation[index].scoreMinimo = true;
        } else {
          validation[index] = {
            texts: "El score mínimo no debe ser negativo",
            scoreMinimo: true,
            scoreMaximo: false,
            percentage: false,
          };
        }
      }
      if (parseInt(items.scoreMaximo) < 0) {
        if (validation[index]) {
          validation[index].texts += " El score máximo no debe ser negativo";
          validation[index].scoreMaximo = true;
        } else {
          validation[index] = {
            texts: "El score máximo no debe ser negativo",
            scoreMinimo: false,
            scoreMaximo: true,
            percentage: false,
          };
        }
      }
      const regex = /^(0(\.\d+)?|1(\.0+)?)$/;
      if (items.percentage != null && items.percentage != "") {
        if (!regex.test(items.percentage)) {
          if (validation[index]) {
            validation[index].texts +=
              " El porcentaje debe estar entre los valores 0  y 1";
            validation[index].percentage = true;
          } else {
            validation[index] = {
              texts: "El porcentaje debe estar entre los valores 0  y 1",
              scoreMinimo: false,
              scoreMaximo: false,
              percentage: true,
            };
          }
        }
      }
    });
    for (let i = 0; i < values.length - 1; i++) {
      if (
        !isNaN(parseInt(values[i].scoreMaximo)) &&
        !isNaN(parseInt(values[i + 1].scoreMinimo))
      ) {
        if (
          parseInt(values[i + 1].scoreMinimo) -
            parseInt(values[i].scoreMaximo) !=
          1
        ) {
          if (validation[i]) {
            validation[i].texts +=
              " El valor del score máximo de este intervelo y el score mínimo del siguiente intervalo no son continuos en sus valores";
            validation[i].scoreMaximo = true;
          } else {
            validation[i] = {
              texts:
                "El valor del score máximo de este intervelo y el score mínimo del siguiente intervalo no son continuos en sus valores",
              scoreMinimo: false,
              scoreMaximo: true,
              percentage: false,
            };
          }
        }
      }
    }
    setValidations(validation);
    return validation;
  };

  const validateTickets = (includeFpdErrors = false) => {
    const validation = {};
    tickets.forEach((items, index) => {
      if (validation[index]) {
        validation[index].texts = "";
      }
      console.log(items.ticketMinimo);
      if (isNaN(items.ticketMinimo)) {
        if (validation[index]) {
          validation[index].texts = "Los campos deben tener valores numéricos";
          validation[index].ticketMinimo = true;
        } else {
          validation[index] = {
            texts: "Los campos deben tener valores numéricos",
            ticketMinimo: true,
            ticketMaximo: false,
          };
        }
      }
      if (isNaN(items.ticketMaximo)) {
        if (validation[index]) {
          validation[index].texts = "Los campos deben tener valores numéricos";
          validation[index].ticketMaximo = true;
        } else {
          validation[index] = {
            texts: "Los campos deben tener valores numéricos",
            ticketMinimo: false,
            ticketMaximo: true,
          };
        }
      }
      if (parseInt(items.ticketMinimo) < 0) {
        if (validation[index]) {
          validation[index].texts += "El ticket mínimo no debe ser negativo";
          validation[index].ticketMinimo = true;
        } else {
          validation[index] = {
            texts: "El ticket mínimo no debe ser negativo",
            ticketMinimo: true,
            ticketMaximo: false,
          };
        }
      }
      if (parseInt(items.ticketMaximo) < 0) {
        if (validation[index]) {
          validation[index].texts += "El ticket máximo no debe ser negativo";
          validation[index].ticketMaximo = true;
        } else {
          validation[index] = {
            texts: "El ticket máximo no debe ser negativo",
            ticketMinimo: false,
            ticketMaximo: true,
          };
        }
      }
      if (parseInt(items.ticketMaximo) - parseInt(items.ticketMinimo) < 0) {
        if (validation[index]) {
          validation[index].texts =
            "El ticket mínimo no puede ser mayor al ticker máximo";
          validation[index].ticketMinimo = true;
          validation[index].ticketMaximo = true;
        } else {
          validation[index] = {
            texts: "El ticket mínimo no puede ser mayor al ticker máximo",
            ticketMinimo: true,
            ticketMaximo: true,
          };
        }
      }

      const fpdErrors = getFpdValidationErrors(items, version);
      if (includeFpdErrors && Object.keys(fpdErrors).length > 0) {
        const fpdText =
          version === "V2"
            ? "Los campos Score mínimo de pago contienen errores"
            : "Los campos Score First Payment Default contienen errores";
        if (validation[index]) {
          validation[index].texts += ` ${fpdText}`;
        } else {
          validation[index] = {
            texts: fpdText,
            ticketMinimo: false,
            ticketMaximo: false,
          };
        }
        Object.keys(fpdErrors).forEach((field) => {
          validation[index][field] = true;
        });
      }
    });
    for (let i = 0; i < tickets.length - 1; i++) {
      if (
        !isNaN(parseInt(tickets[i].ticketMaximo)) &&
        !isNaN(parseInt(tickets[i + 1].ticketMinimo))
      ) {
        if (
          parseInt(tickets[i + 1].ticketMinimo) -
            parseInt(tickets[i].ticketMaximo) !=
          1
        ) {
          if (validation[i]) {
            validation[i].texts +=
              " El valor del ticket máximo de este intervelo y el ticket mínimo del siguiente intervalo no son continuos en sus valores";
            validation[i].ticketMaximo = true;
          } else {
            validation[i] = {
              texts:
                "El valor del ticket máximo de este intervelo y el ticket mínimo del siguiente intervalo no son continuos en sus valores",
              ticketMinimo: false,
              ticketMaximo: true,
            };
          }
        }
      }
    }
    setVerifications(validation);
    return validation;
  };

  const validationValue = (event) => {
    if (isNaN(event.target.value)) {
      validation.tickets[event.target.name] =
        "Esta variable debe contener valores numéricos";
    } else if (parseInt(event.target.value) < 0) {
      validation.tickets[event.target.name] =
        "Esta variable debe contener valores positivos";
    } else {
      if (validation.tickets[event.target.name]) {
        delete validation.tickets[event.target.name];
      }
    }
    setValidation({ ...validation });
  };

  const validatePolicy = () => {
    const validation = {
      politica: {},
      tickets: {},
    };
    if (isNaN(policyUpdate.baseGastoPersonal)) {
      validation.politica["baseGastoPersonal"] = {
        texts: "La base de gasto personal debe tener valores numéricos",
      };
    }
    if (parseInt(policyUpdate.baseGastoPersonal) < 0) {
      validation.politica["baseGastoPersonal"] = {
        texts: "La base de gasto personal debe tener valores positivos",
      };
    }
    if (isNaN(policyUpdate.gastoDependientes)) {
      validation.politica["gastoDependientes"] = {
        texts: "El gasto dependientes debe tener valores numéricos",
      };
    }
    if (parseInt(policyUpdate.gastoDependientes) < 0) {
      validation.politica["gastoDependientes"] = {
        texts: "El gasto dependientes debe tener valores positivos",
      };
    }
    if (isNaN(policyUpdate.porcentajeUtilizacionSobreIngresoBruto)) {
      validation.politica["porcentajeUtilizacionSobreIngresoBruto"] = {
        texts: "El porcentaje debe tener valores numéricos",
      };
    }
    if (parseInt(policyUpdate.porcentajeUtilizacionSobreIngresoBruto) < 0) {
      validation.politica["porcentajeUtilizacionSobreIngresoBruto"] = {
        texts: "El porcentaje debe tener valores positivos",
      };
    }
    const regex1 = /^(0(\.\d+)?|1(\.0+)?)$/;
    if (!isNaN(parseInt(policyUpdate.porcentajeUtilizacionSobreIngresoBruto))) {
      if (!regex1.test(policyUpdate.porcentajeUtilizacionSobreIngresoBruto)) {
        validation.politica["porcentajeUtilizacionSobreIngresoBruto"] = {
          texts: "El porcentaje debe tener valores entre 0 y 1",
        };
      }
    }
    if (isNaN(policyUpdate.porcentajeUtilizacionSobreIngresoNeto)) {
      validation.politica["porcentajeUtilizacionSobreIngresoNeto"] = {
        texts: "El porcentaje debe tener valores numéricos",
      };
    }
    if (parseInt(policyUpdate.porcentajeUtilizacionSobreIngresoNeto) < 0) {
      validation.politica["porcentajeUtilizacionSobreIngresoNeto"] = {
        texts: "El porcentaje debe tener valores positivos",
      };
    }
    const regex2 = /^(0(\.\d+)?|1(\.0+)?)$/;
    if (!isNaN(parseInt(policyUpdate.porcentajeUtilizacionSobreIngresoNeto))) {
      if (!regex2.test(policyUpdate.porcentajeUtilizacionSobreIngresoNeto)) {
        validation.politica["porcentajeUtilizacionSobreIngresoNeto"] = {
          texts: "El porcentaje debe tener valores entre 0 y 1",
        };
      }
    }
    if (isNaN(policyUpdate.edadMinima)) {
      validation.politica["edadMinima"] = {
        texts: "La edad mínima debe tener valores numéricos",
      };
    }
    if (parseInt(policyUpdate.edadMinima) < 0) {
      validation.politica["edadMinima"] = {
        texts: "La edad mínima debe tener valores positivos",
      };
    }
    if (isNaN(policyUpdate.edadMaxima)) {
      validation.politica["edadMaxima"] = {
        texts: "La edad máxima debe tener valores numéricos",
      };
    }
    if (parseInt(policyUpdate.edadMaxima) < 0) {
      validation.politica["edadMaxima"] = {
        texts: "La edad máxima debe tener valores positivos",
      };
    }
    setValidation(validation);
    return validation;
  };

  const validateBeforeSubmit = () => {
    const ticketFieldErrors = { ...validation.tickets };
    const intervalErrors = validateIntervals();
    const ticketErrors = validateTickets(true);
    const policyErrors = validatePolicy();
    policyErrors.tickets = ticketFieldErrors;
    setValidation(policyErrors);

    if (Object.keys(intervalErrors).length > 0) {
      setSnackbar(true);
      setAlerta("Existen campos de intervalos de credibilidad con error");
      setSeverity("error");
      return false;
    }

    if (Object.keys(ticketErrors).length > 0) {
      setSnackbar(true);
      setAlerta("Existen campos de tickets con error");
      setSeverity("error");
      return false;
    }

    if (
      Object.keys(policyErrors.politica).length > 0 ||
      Object.keys(ticketFieldErrors).length > 0
    ) {
      setSnackbar(true);
      setAlerta("Existen errores en los valores de la politica o los tickets");
      setSeverity("error");
      return false;
    }

    return true;
  };

  const handleGenerate = () => {
    if (!validateBeforeSubmit()) {
      return;
    }

    const policySave = {
      version: version,
      name: policyUpdate.name,
      baseGastoPersonal: policyUpdate.baseGastoPersonal,
      gastoDependientes: policyUpdate.gastoDependientes,
      porcentajeUtilizacionSobreIngresoNeto:
        policyUpdate.porcentajeUtilizacionSobreIngresoNeto,
      porcentajeUtilizacionSobreIngresoBruto:
        policyUpdate.porcentajeUtilizacionSobreIngresoBruto,
      edadMinima: policyUpdate.edadMinima,
      edadMaxima: policyUpdate.edadMaxima,
    };
    const intervalPolicies = values.map((items) => ({
      scoreMinimo: items.scoreMinimo,
      scoreMaximo: items.scoreMaximo,
      percentage: items.percentage,
    }));
    const valueSegmentations = tickets.map((items) => ({
      ticketMinimo: items.ticketMinimo,
      ticketMaximo: items.ticketMaximo,
      maxCuota: items.maxCuota != null ? parseInt(items.maxCuota) : null,
      creditosRealesIngresosNoValidados:
        items.creditosRealesIngresosNoValidados,
      creditosTelcoIngresosNoValidados: items.creditosTelcoIngresosNoValidados,
      creditosFinancierosIngresosNoValidados:
        items.creditosFinancierosIngresosNoValidados,
      ...buildTicketScorePayload(items, version),
      creditosRealesIngresosValidados: items.creditosRealesIngresosValidados,
      creditosTelcoIngresosValidados: items.creditosTelcoIngresosValidados,
      creditosFinancierosIngresosValidados:
        items.creditosFinancierosIngresosValidados,
      tarifafgaIngresosNoValidados: items.tarifafgaIngresosNoValidados,
      tarifafgaIngresosValidados: items.tarifafgaIngresosValidados,
      valueSetting: {
        realFinancieroIngresosNoValidados:
          items.settingsNoValidados.realFinanciero,
        realTelcoIngresosNoValidados: items.settingsNoValidados.realTelco,
        telcoFinancieroIngresosNoValidados:
          items.settingsNoValidados.financieroTelco,
        realFinancieroIngresosValidados: items.settingsValidados.realFinanciero,
        realTelcoIngresosValidados: items.settingsValidados.realTelco,
        telcoFinancieroIngresosValidados:
          items.settingsValidados.financieroTelco,
      },
      valueStructures: [
        ...items.valueStructuresNoValidados.map((item) => ({
          creditosReales: item.creditosReales,
          creditosTelco: item.creditosTelco,
          creditosFinancieros: item.creditosFinancieros,
          esIngresoValidado: false,
        })),
        ...items.valueStructuresValidados.map((item) => ({
          creditosReales: item.creditosReales,
          creditosTelco: item.creditosTelco,
          creditosFinancieros: item.creditosFinancieros,
          esIngresoValidado: true,
        })),
      ],
    }));
    console.log(policySave);
    console.log(intervalPolicies);
    console.log(valueSegmentations);
    axiosClient
      .post(
        "/v1/policies/policy-values",
        {
          policy: policySave,
          intervalPolicies: intervalPolicies,
          valueSegmentations: valueSegmentations,
        },
        {
          headers: { "Content-Type": "application/json" },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          const policy = response.data;
          if (version === versions[0]) {
            setVersion(versions[1]);
          } else {
            setVersion(versions[0]);
          }
          setPolicyUpdate({
            version: null,
            name: "",
            baseGastoPersonal: "",
            gastoDependientes: "",
            porcentajeUtilizacionSobreIngresoBruto: "",
            porcentajeUtilizacionSobreIngresoNeto: "",
            edadMinima: "",
            edadMaxima: "",
          });
          setPolicy(null);
          setTickets([
            {
              id: 1,
              ticketMinimo: null,
              ticketMaximo: null,
              maxCuota: null,
              creditosRealesIngresosNoValidados: null,
              creditosTelcoIngresosNoValidados: null,
              creditosFinancierosIngresosNoValidados: null,
              creditosRealesTelcoIngresosNoValidados: null,
              scoreIngresosNoValidados: null,
              scoreMaximoFpdIngresoNoValidado: null,
              porcentajeUtilizacionIngresosNoValidados: null,
              creditosRealesIngresosValidados: null,
              creditosTelcoIngresosValidados: null,
              creditosFinancierosIngresosValidados: null,
              creditosRealesTelcoIngresosValidados: null,
              scoreIngresosValidados: null,
              scoreMaximoFpdIngresoValidado: null,
      ...EMPTY_SCORE_MINIMO_PAGAR,
              porcentajeUtilizacionIngresosValidados: null,
              tarifafgaIngresosNoValidados: null,
              tarifafgaIngresosValidados: null,
              settingsNoValidados: {
                realTelco: "O",
                realFinanciero: "O",
                financieroTelco: "O",
              },
              settingsValidados: {
                realTelco: "O",
                realFinanciero: "O",
                financieroTelco: "O",
              },
            },
          ]);
        } else {
          console.log("Error petition");
        }
      })
      .catch((error) => {
        console.log("Error fetch " + error.message);
      });
  };

  const handleUpdatePolicy = () => {
    if (!validateBeforeSubmit()) {
      return;
    }

    setBackdrop(true);
      const policySave = {
        version: version,
        name: policyUpdate.name,
        baseGastoPersonal: policyUpdate.baseGastoPersonal,
        gastoDependientes: policyUpdate.gastoDependientes,
        porcentajeUtilizacionSobreIngresoNeto:
          policyUpdate.porcentajeUtilizacionSobreIngresoNeto,
        porcentajeUtilizacionSobreIngresoBruto:
          policyUpdate.porcentajeUtilizacionSobreIngresoBruto,
        edadMinima: policyUpdate.edadMinima,
        edadMaxima: policyUpdate.edadMaxima,
      };
      const intervalPolicies = values.map((items) => ({
        scoreMinimo: items.scoreMinimo,
        scoreMaximo: items.scoreMaximo,
        percentage: items.percentage,
      }));
      const valueSegmentations = tickets.map((items) => ({
        ticketMinimo: items.ticketMinimo,
        ticketMaximo: items.ticketMaximo,
        maxCuota: items.maxCuota != null ? parseInt(items.maxCuota) : null,
        creditosRealesIngresosNoValidados:
          items.creditosRealesIngresosNoValidados,
        creditosTelcoIngresosNoValidados:
          items.creditosTelcoIngresosNoValidados,
        creditosFinancierosIngresosNoValidados:
          items.creditosFinancierosIngresosNoValidados,
        ...buildTicketScorePayload(items, version),
        creditosRealesIngresosValidados: items.creditosRealesIngresosValidados,
        creditosTelcoIngresosValidados: items.creditosTelcoIngresosValidados,
        creditosFinancierosIngresosValidados:
          items.creditosFinancierosIngresosValidados,
        tarifafgaIngresosNoValidados: items.tarifafgaIngresosNoValidados,
        tarifafgaIngresosValidados: items.tarifafgaIngresosValidados,
        valueSetting: {
          realFinancieroIngresosNoValidados:
            items.settingsNoValidados.realFinanciero,
          realTelcoIngresosNoValidados: items.settingsNoValidados.realTelco,
          telcoFinancieroIngresosNoValidados:
            items.settingsNoValidados.financieroTelco,
          realFinancieroIngresosValidados:
            items.settingsValidados.realFinanciero,
          realTelcoIngresosValidados: items.settingsValidados.realTelco,
          telcoFinancieroIngresosValidados:
            items.settingsValidados.financieroTelco,
        },
        valueStructures: [
          ...items.valueStructuresNoValidados.map((item) => ({
            creditosReales: item.creditosReales,
            creditosTelco: item.creditosTelco,
            creditosFinancieros: item.creditosFinancieros,
            esIngresoValidado: false,
          })),
          ...items.valueStructuresValidados.map((item) => ({
            creditosReales: item.creditosReales,
            creditosTelco: item.creditosTelco,
            creditosFinancieros: item.creditosFinancieros,
            esIngresoValidado: true,
          })),
        ],
      }));
      axiosClient
        .patch(
          `/v1/policies/policy-values/${policyUpdate.uuid}`,
          {
            policy: policySave,
            intervalPolicies: intervalPolicies,
            valueSegmentations: valueSegmentations,
          },
          {
            headers: { "Content-Type": "application/json" },
          },
        )
        .then((response) => {
          if (response.status === 200) {
            setBackdrop(false);
            setSnackbar(true);
            setAlerta("Se ha modificado exitosamente la política");
            setSeverity("success");

            const policy = response.data;
            if (version === versions[0]) {
              setVersion(versions[1]);
            } else {
              setVersion(versions[0]);
            }

            setPolicyUpdate({
              version: null,
              name: "",
              baseGastoPersonal: "",
              gastoDependientes: "",
              porcentajeUtilizacionSobreIngresoBruto: "",
              porcentajeUtilizacionSobreIngresoNeto: "",
              edadMinima: "",
              edadMaxima: "",
            });

            setPolicy(null);
            setTickets([
              {
                id: 1,
                ticketMinimo: null,
                ticketMaximo: null,
                maxCuota: null,
                creditosRealesIngresosNoValidados: null,
                creditosTelcoIngresosNoValidados: null,
                creditosFinancierosIngresosNoValidados: null,
                creditosRealesTelcoIngresosNoValidados: null,
                scoreIngresosNoValidados: null,
                scoreMaximoFpdIngresoNoValidado: null,
                porcentajeUtilizacionIngresosNoValidados: null,
                creditosRealesIngresosValidados: null,
                creditosTelcoIngresosValidados: null,
                creditosFinancierosIngresosValidados: null,
                creditosRealesTelcoIngresosValidados: null,
                scoreIngresosValidados: null,
                scoreMaximoFpdIngresoValidado: null,
      ...EMPTY_SCORE_MINIMO_PAGAR,
                porcentajeUtilizacionIngresosValidados: null,
                tarifafgaIngresosNoValidados: null,
                tarifafgaIngresosValidados: null,
                settingsNoValidados: {
                  realTelco: "O",
                  realFinanciero: "O",
                  financieroTelco: "O",
                },
                settingsValidados: {
                  realTelco: "O",
                  realFinanciero: "O",
                  financieroTelco: "O",
                },
              },
            ]);
          } else {
            console.log("Error petition");
            setBackdrop(false);
            setSnackbar(true);
            setAlerta(
              "Ha ocurrido un error en la actualización, por favor intenta de nuevo más tarde",
            );
            setSeverity("error");
          }
        })
        .catch((error) => {
          console.log("Error fetch " + error.message);
          setBackdrop(false);
          setSnackbar(true);
          setAlerta(
            "Ha ocurrido un error en la actualización, por favor intenta de nuevo más tarde",
          );
          setSeverity("error");
        });
  };

  const handleTop = (index) => {
    if (index !== 0) {
      const ticket = tickets[index];
      const newTicket = tickets[index - 1];
      tickets[index] = newTicket;
      tickets[index - 1] = ticket;
      setTickets([...tickets]);
    }
  };

  const handleDown = (index) => {
    if (index !== tickets.length - 1) {
      const ticket = tickets[index];
      const newTicket = tickets[index + 1];
      tickets[index] = newTicket;
      tickets[index + 1] = ticket;
      setTickets([...tickets]);
    }
  };

  const handleChangeValue = (event, index) => {
    const { checked } = event.target;
    const [name, group] = event.target.name?.split(",");
    if (group === "ingresos-no-validados") {
      setTicketUpdate((prev) => {
        const prevArr = prev.valueStructuresNoValidados || [];
        const newArr = [...prevArr];
        newArr[index] = { ...newArr[index], [name]: checked };
        return {
          ...prev,
          valueStructuresNoValidados: newArr,
        };
      });
    } else {
      setTicketUpdate((prev) => {
        const prevArr = prev.valueStructuresValidados || [];
        const newArr = [...prevArr];
        newArr[index] = { ...newArr[index], [name]: checked };
        return {
          ...prev,
          valueStructuresValidados: newArr,
        };
      });
    }
  };

  const handleSumValue = (group) => {
    if (group === "ingresos-no-validados") {
      const id = ticketUpdate.valueStructuresNoValidados
        .map((item) => item.id)
        .reduce((acc, cur) => (acc > cur ? acc : cur), 0);
      setTicketUpdate((prev) => {
        const prevArr = prev.valueStructuresNoValidados || [];
        const newArr = [
          ...prevArr,
          {
            id: id + 1,
            creditosReales: true,
            creditosTelco: true,
            creditosFinancieros: true,
          },
        ];
        return {
          ...prev,
          valueStructuresNoValidados: newArr,
        };
      });
    } else {
      const id = ticketUpdate.valueStructuresValidados
        .map((item) => item.id)
        .reduce((acc, cur) => (acc > cur ? acc : cur), 0);
      setTicketUpdate((prev) => {
        const prevArr = prev.valueStructuresValidados || [];
        const newArr = [
          ...prevArr,
          {
            id: id + 1,
            creditosReales: true,
            creditosTelco: true,
            creditosFinancieros: true,
          },
        ];
        return {
          ...prev,
          valueStructuresValidados: newArr,
        };
      });
    }
  };

  const handleDeleteValue = (index, group) => {
    if (group === "ingresos-no-validados") {
      setTicketUpdate((prev) => {
        const prevArr = prev.valueStructuresNoValidados || [];
        const newArr = prevArr.filter((item, i) => i !== index);
        return {
          ...prev,
          valueStructuresNoValidados: newArr,
        };
      });
    } else {
      setTicketUpdate((prev) => {
        const prevArr = prev.valueStructuresValidados || [];
        const newArr = prevArr.filter((item, i) => i !== index);
        return {
          ...prev,
          valueStructuresValidados: newArr,
        };
      });
    }
  };

  console.log(ticketUpdate);

  useEffect(() => {
    axiosClient
      .get(`/v1/policies/${version}`)
      .then((response) => {
        if (response.status === 200) {
          setPolicies(response.data);
          console.log(response.data);
        } else {
          console.log("Error fetch");
        }
      })
      .catch((error) => {
        console.log("Bad fetch " + error.message);
      });
  }, [version]);

  useEffect(() => {
    validateIntervals();
  }, [valuesSize]);

  useEffect(() => {
    validateTickets();
  }, [tickets]);

  useEffect(() => {
    validatePolicy();
  }, [policyUpdate]);

  return (
    <React.Fragment>
      <br></br>
      <Box sx={{ width: "100%", marginTop: "1.9rem", marginBottom: "1rem" }}>
        <Container>
          <Item></Item>
          <Item>.</Item>
          <Grid container marginTop={2} alignItems={"center"}>
            <h1>Politicas</h1>
            <Box
              sx={{
                width: "50vw",
                padding: "1rem",
                display: "flex",
                gap: "1rem",
              }}
            >
              <ButtonPrincipal onClick={handleUpdatePolicy}>
                Modificar
              </ButtonPrincipal>
              <ButtonPrincipal onClick={handleGenerate}>Crear</ButtonPrincipal>
              <ButtonPrincipal onClick={handleSegmentation}>
                Asignar políticas
              </ButtonPrincipal>
            </Box>
            <Grid sx={{ width: "100%" }} marginTop={2}>
              <Box
                mt={5}
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-around",
                  gap: "1rem",
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="version">Versión politica</InputLabel>
                  <Select
                    labelId="version"
                    id="version-select"
                    label="Versión politica"
                    value={version}
                    onChange={handleVersion}
                  >
                    {versions.map((version) => (
                      <MenuItem key={version} value={version}>
                        {version}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="politica">Politica</InputLabel>
                  <Select
                    labelId="politica"
                    id="politica-select"
                    label="Politica"
                    value={policy}
                    onChange={handlePolicy}
                  >
                    {policies.map((items) => (
                      <MenuItem key={items?.policy?.name} value={items}>
                        {items?.policy?.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box mt={5}>
                <FormControl fullWidth>
                  <TextField
                    id="id"
                    label="Id Política"
                    disabled
                    value={
                      policy?.policy?.uuid != null ? policy?.policy?.uuid : " "
                    }
                  ></TextField>
                </FormControl>
              </Box>
              <Box mt={5}>
                <FormControl fullWidth>
                  <TextField
                    id="name"
                    label="Nombre política"
                    variant="outlined"
                    name="name"
                    value={policyUpdate.name}
                    error={validation.politica["name"] ? true : false}
                    onChange={handleUpdate}
                  ></TextField>
                </FormControl>
                {validation.politica["name"] ? (
                  <Box mt={2} sx={{ color: "red" }}>
                    {validation.politica["name"].texts}
                  </Box>
                ) : null}
              </Box>
              {version == versions[1] && (
                <>
                  <Box mt={5}>
                    <FormControl fullWidth>
                      <TextField
                        id="base-gasto"
                        label="Base gasto personal"
                        variant="outlined"
                        name="baseGastoPersonal"
                        value={policyUpdate.baseGastoPersonal}
                        error={
                          validation.politica["baseGastoPersonal"]
                            ? true
                            : false
                        }
                        onChange={handleUpdate}
                      ></TextField>
                    </FormControl>
                    {validation.politica["baseGastoPersonal"] ? (
                      <Box mt={2} sx={{ color: "red" }}>
                        {validation.politica["baseGastoPersonal"].texts}
                      </Box>
                    ) : null}
                  </Box>
                  <Box mt={5}>
                    <FormControl fullWidth>
                      <TextField
                        id="dependents"
                        label="Gasto dependientes"
                        variant="outlined"
                        name="gastoDependientes"
                        value={policyUpdate.gastoDependientes}
                        error={
                          validation.politica["gastoDependientes"]
                            ? true
                            : false
                        }
                        onChange={handleUpdate}
                      ></TextField>
                    </FormControl>
                    {validation.politica["gastoDependientes"] ? (
                      <Box mt={2} sx={{ color: "red" }}>
                        {validation.politica["gastoDependientes"].texts}
                      </Box>
                    ) : null}
                  </Box>
                  <Box mt={5}>
                    <FormControl fullWidth>
                      <TextField
                        id="utilizacion-bruto"
                        label="Porcentaje utilización sobre ingreso bruto"
                        variant="outlined"
                        name="porcentajeUtilizacionSobreIngresoBruto"
                        value={
                          policyUpdate.porcentajeUtilizacionSobreIngresoBruto
                        }
                        error={
                          validation.politica[
                            "porcentajeUtilizacionSobreIngresoBruto"
                          ]
                            ? true
                            : false
                        }
                        onChange={handleUpdate}
                      ></TextField>
                    </FormControl>
                    {validation.politica[
                      "porcentajeUtilizacionSobreIngresoBruto"
                    ] ? (
                      <Box mt={2} sx={{ color: "red" }}>
                        {
                          validation.politica[
                            "porcentajeUtilizacionSobreIngresoBruto"
                          ].texts
                        }
                      </Box>
                    ) : null}
                  </Box>
                  <Box mt={5}>
                    <FormControl fullWidth>
                      <TextField
                        id="utilizacion-neto"
                        label="Porcentaje utilización sobre el ingreso neto"
                        variant="outlined"
                        name="porcentajeUtilizacionSobreIngresoNeto"
                        value={
                          policyUpdate.porcentajeUtilizacionSobreIngresoNeto
                        }
                        error={
                          validation.politica[
                            "porcentajeUtilizacionSobreIngresoNeto"
                          ]
                            ? true
                            : false
                        }
                        onChange={handleUpdate}
                      ></TextField>
                    </FormControl>
                    {validation.politica[
                      "porcentajeUtilizacionSobreIngresoNeto"
                    ] ? (
                      <Box mt={2} sx={{ color: "red" }}>
                        {
                          validation.politica[
                            "porcentajeUtilizacionSobreIngresoNeto"
                          ].texts
                        }
                      </Box>
                    ) : null}
                  </Box>
                  <Box mt={5}>
                    <FormControl fullWidth>
                      <TextField
                        id="edad-minima"
                        label="Edad mínima"
                        variant="outlined"
                        name="edadMinima"
                        value={policyUpdate.edadMinima}
                        error={validation.politica["edadMinima"] ? true : false}
                        onChange={handleUpdate}
                      ></TextField>
                    </FormControl>
                    {validation.politica["edadMinima"] ? (
                      <Box mt={2} sx={{ color: "red" }}>
                        {validation.politica["edadMinima"].texts}
                      </Box>
                    ) : null}
                  </Box>
                  <Box mt={5}>
                    <FormControl fullWidth>
                      <TextField
                        id="edad-maxima"
                        label="Edad máxima"
                        variant="outlined"
                        name="edadMaxima"
                        value={policyUpdate.edadMaxima}
                        error={validation.politica["edadMaxima"] ? true : false}
                        onChange={handleUpdate}
                      ></TextField>
                    </FormControl>
                    {validation.politica["edadMaxima"] ? (
                      <Box mt={2} sx={{ color: "red" }}>
                        {validation.politica["edadMaxima"].texts}
                      </Box>
                    ) : null}
                  </Box>
                  <Box display={"flex"} alignItems={"center"} gap={"1rem"}>
                    <h2>Porcentajes credibilidad</h2>
                    <ButtonPrincipal
                      sx={{ width: "fit-content", height: "fit-content" }}
                      onClick={sumValues}
                    >
                      +
                    </ButtonPrincipal>
                  </Box>
                  {values.length == 1
                    ? values.map((items, index) => (
                        <Box
                          mt={5}
                          key={
                            items.id +
                            `${policyUpdate.name != "" || policyUpdate.name != null ? policyUpdate.name : "varios"}`
                          }
                        >
                          <Box sx={{ display: "flex", gap: "1rem" }}>
                            <FormControl fullWidth>
                              <TextField
                                id={`score-min-${items?.id}`}
                                label="Score Mínimo"
                                variant="outlined"
                                name="scoreMinimo"
                                value={items.scoreMinimo}
                                error={
                                  validations[index]
                                    ? validations[index]?.scoreMinimo
                                    : false
                                }
                                onBlur={validateIntervals}
                                onChange={(event) =>
                                  updatePercentage(event, index)
                                }
                              ></TextField>
                            </FormControl>
                            <FormControl fullWidth>
                              <TextField
                                id={`score-max-${items.id}`}
                                label="Score Máximo"
                                variant="outlined"
                                name="scoreMaximo"
                                value={items.scoreMaximo}
                                error={
                                  validations[index]
                                    ? validations[index]?.scoreMaximo
                                    : false
                                }
                                onBlur={validateIntervals}
                                onChange={(event) =>
                                  updatePercentage(event, index)
                                }
                              ></TextField>
                            </FormControl>
                            <FormControl fullWidth>
                              <TextField
                                id={`percentage-${items.id}`}
                                label="Porcentaje"
                                variant="outlined"
                                name="percentage"
                                value={items.percentage}
                                error={
                                  validations[index]
                                    ? validations[index]?.percentage
                                    : false
                                }
                                onBlur={validateIntervals}
                                onChange={(event) =>
                                  updatePercentage(event, index)
                                }
                              ></TextField>
                            </FormControl>
                          </Box>
                          {validations[index] ? (
                            <Box mt={2} sx={{ color: "red" }}>
                              {validations[index].texts}
                            </Box>
                          ) : null}
                        </Box>
                      ))
                    : values.map((items, index) => (
                        <Box
                          mt={5}
                          key={
                            items.id +
                            `${policyUpdate.name != "" || policyUpdate.name != null ? policyUpdate.name : "varios"}`
                          }
                        >
                          <Box sx={{ display: "flex", gap: "1rem" }}>
                            <FormControl fullWidth>
                              <TextField
                                id={`score-min-${items.id}`}
                                label="Score Mínimo"
                                variant="outlined"
                                name="scoreMinimo"
                                value={items.scoreMinimo}
                                error={
                                  validations[index]
                                    ? validations[index]?.scoreMinimo
                                    : false
                                }
                                onBlur={validateIntervals}
                                onChange={(event) =>
                                  updatePercentage(event, index)
                                }
                              ></TextField>
                            </FormControl>
                            <FormControl fullWidth>
                              <TextField
                                id={`score-max-${items.id}`}
                                label="Score Máximo"
                                variant="outlined"
                                name="scoreMaximo"
                                value={items.scoreMaximo}
                                error={
                                  validations[index]
                                    ? validations[index]?.scoreMaximo
                                    : false
                                }
                                onBlur={validateIntervals}
                                onChange={(event) =>
                                  updatePercentage(event, index)
                                }
                              ></TextField>
                            </FormControl>
                            <FormControl fullWidth>
                              <TextField
                                id={`percentage-${items.id}`}
                                label="Porcentaje"
                                variant="outlined"
                                name="percentage"
                                value={items.percentage}
                                error={
                                  validations[index]
                                    ? validations[index]?.percentage
                                    : false
                                }
                                onBlur={validateIntervals}
                                onChange={(event) =>
                                  updatePercentage(event, index)
                                }
                              ></TextField>
                            </FormControl>
                            <ButtonPrincipal
                              sx={{
                                width: "fit-content",
                                height: "fit-content",
                                margin: "auto",
                              }}
                              onClick={() => deletePercentage(index)}
                            >
                              -
                            </ButtonPrincipal>
                          </Box>
                          {validations[index] ? (
                            <Box mt={2} sx={{ color: "red" }}>
                              {validations[index].texts}
                            </Box>
                          ) : null}
                        </Box>
                      ))}
                </>
              )}
              <Box display={"flex"} alignItems={"center"} gap={"1rem"} mt={5}>
                <h2>Tickets</h2>
                <ButtonPrincipal
                  sx={{ width: "fit-content", height: "fit-content" }}
                  onClick={sumTicket}
                >
                  +
                </ButtonPrincipal>
              </Box>
              <Grid container>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Ticket Mínimo</TableCell>
                        <TableCell>Ticket Máximo</TableCell>
                        <TableCell>Cuotas máximas</TableCell>
                        <TableCell>Cuotas máximas</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tickets.length == 1
                        ? tickets.map((items, number) => (
                            <TableRow key={items.id}>
                              <TableCell
                                sx={
                                  verifications[number] &&
                                  verifications[number]?.ticketMinimo && {
                                    color: "red",
                                  }
                                }
                              >
                                {items.ticketMinimo ? items.ticketMinimo : 0}
                              </TableCell>
                              <TableCell
                                sx={
                                  verifications[number] &&
                                  verifications[number]?.ticketMaximo && {
                                    color: "red",
                                  }
                                }
                              >
                                {items.ticketMaximo ? items.ticketMaximo : 0}
                              </TableCell>
                              <TableCell>
                                {items.maxCuota ? items.maxCuota : 0}
                              </TableCell>
                              <TableCell>
                                <ButtonPrincipal
                                  sx={{
                                    width: "fit-content",
                                    height: "fit-content",
                                    margin: "auto",
                                  }}
                                  onClick={() => editTicket(number)}
                                >
                                  <EditIcon></EditIcon>
                                </ButtonPrincipal>
                              </TableCell>
                              <TableCell sx={{ color: "red" }}>
                                {verifications[number] &&
                                  verifications[number].texts}
                              </TableCell>
                            </TableRow>
                          ))
                        : tickets.map((items, number) => (
                            <TableRow key={items.id}>
                              <TableCell
                                sx={
                                  verifications[number] &&
                                  verifications[number]?.ticketMinimo && {
                                    color: "red",
                                  }
                                }
                              >
                                {items.ticketMinimo ? items.ticketMinimo : 0}
                              </TableCell>
                              <TableCell
                                sx={
                                  verifications[number] &&
                                  verifications[number]?.ticketMaximo && {
                                    color: "red",
                                  }
                                }
                              >
                                {items.ticketMaximo ? items.ticketMaximo : 0}
                              </TableCell>
                              <TableCell>
                                {items.maxCuota ? items.maxCuota : 0}
                              </TableCell>
                              <TableCell>
                                <ButtonPrincipal
                                  sx={{
                                    width: "fit-content",
                                    height: "fit-content",
                                    margin: "auto",
                                  }}
                                  onClick={() => editTicket(number)}
                                >
                                  <EditIcon></EditIcon>
                                </ButtonPrincipal>
                              </TableCell>
                              <TableCell>
                                <ButtonPrincipal
                                  sx={{
                                    width: "fit-content",
                                    height: "fit-content",
                                    margin: "auto",
                                  }}
                                  onClick={() => deleteTicket(number)}
                                >
                                  -
                                </ButtonPrincipal>
                              </TableCell>
                              <TableCell sx={{ color: "red" }}>
                                {verifications[number] &&
                                  verifications[number].texts}
                              </TableCell>
                              <TableCell
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "1rem",
                                }}
                              >
                                <ButtonPrincipal
                                  sx={{
                                    width: "fit-content",
                                    height: "fit-content",
                                  }}
                                  onClick={() => handleTop(number)}
                                >
                                  <ArrowUpward></ArrowUpward>
                                </ButtonPrincipal>
                                <ButtonPrincipal
                                  sx={{
                                    width: "fit-content",
                                    height: "fit-content",
                                  }}
                                  onClick={() => handleDown(number)}
                                >
                                  <ArrowBottom></ArrowBottom>
                                </ButtonPrincipal>
                              </TableCell>
                            </TableRow>
                          ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
      {isTicket && (
        <Modal activeModal={isTicket} handleModal={editTicket}>
          <Grid sx={{ textAlign: "center" }}>
            <h2>Editar ticket</h2>
            <Box sx={{ width: "80%", margin: "auto", paddingBottom: "1rem" }}>
              <form>
                <Box mt={5}>
                  <FormControl fullWidth>
                    <TextField
                      id="ticket-minimo-1"
                      label="Ticket Mínimo"
                      variant="outlined"
                      name="ticketMinimo"
                      value={ticketUpdate?.ticketMinimo}
                      onBlur={validateTickets}
                      onChange={handleUpdateTicket}
                    ></TextField>
                  </FormControl>
                </Box>
                <Box mt={5}>
                  <FormControl fullWidth>
                    <TextField
                      id="ticket-maximo-1"
                      label="Ticket Máximo"
                      variant="outlined"
                      name="ticketMaximo"
                      value={ticketUpdate?.ticketMaximo}
                      onBlur={validateTickets}
                      onChange={handleUpdateTicket}
                    ></TextField>
                  </FormControl>
                </Box>
                {version === versions[1] && (
                  <Box mt={5}>
                    <FormControl fullWidth>
                      <TextField
                        id="max-cuota-1"
                        label="Cuotas máximas"
                        variant="outlined"
                        name="maxCuota"
                        value={ticketUpdate?.maxCuota}
                        error={validation.tickets["maxCuota"] ? true : false}
                        onChange={handleUpdateTicket}
                        onBlur={validationValue}
                      ></TextField>
                    </FormControl>
                    {validation.tickets["maxCuota"] ? (
                      <Box mt={2} sx={{ color: "red" }}>
                        {validation.tickets["maxCuota"]}
                      </Box>
                    ) : null}
                  </Box>
                )}
                <h3>Ingresos no validados</h3>
                <Box mt={5}>
                  <FormControl fullWidth>
                    <TextField
                      id="creditos-real-1"
                      label="Créditos reales"
                      variant="outlined"
                      name="creditosRealesIngresosNoValidados"
                      value={ticketUpdate?.creditosRealesIngresosNoValidados}
                      error={
                        validation.tickets["creditosRealesIngresosNoValidados"]
                          ? true
                          : false
                      }
                      onChange={handleUpdateTicket}
                      onBlur={validationValue}
                    ></TextField>
                  </FormControl>
                  {validation.tickets["creditosRealesIngresosNoValidados"] ? (
                    <Box mt={2} sx={{ color: "red" }}>
                      {validation.tickets["creditosRealesIngresosNoValidados"]}
                    </Box>
                  ) : null}
                </Box>
                <Box mt={5}>
                  <FormControl fullWidth>
                    <TextField
                      id="creditos-telco-1"
                      label="Créditos Telco"
                      variant="outlined"
                      name="creditosTelcoIngresosNoValidados"
                      value={ticketUpdate?.creditosTelcoIngresosNoValidados}
                      error={
                        validation.tickets["creditosTelcoIngresosNoValidados"]
                          ? true
                          : false
                      }
                      onChange={handleUpdateTicket}
                      onBlur={validationValue}
                    ></TextField>
                  </FormControl>
                  {validation.tickets["creditosTelcoIngresosNoValidados"] ? (
                    <Box mt={2} sx={{ color: "red" }}>
                      {validation.tickets["creditosTelcoIngresosNoValidados"]}
                    </Box>
                  ) : null}
                </Box>
                <Box mt={5}>
                  <FormControl fullWidth>
                    <TextField
                      id="creditos-financieros-1"
                      label="Créditos financieros cerrados"
                      variant="outlined"
                      name="creditosFinancierosIngresosNoValidados"
                      value={
                        ticketUpdate?.creditosFinancierosIngresosNoValidados
                      }
                      error={
                        validation.tickets[
                          "creditosFinancierosIngresosNoValidados"
                        ]
                          ? true
                          : false
                      }
                      onChange={handleUpdateTicket}
                      onBlur={validationValue}
                    ></TextField>
                  </FormControl>
                  {validation.tickets[
                    "creditosFinancierosIngresosNoValidados"
                  ] ? (
                    <Box mt={2} sx={{ color: "red" }}>
                      {
                        validation.tickets[
                          "creditosFinancierosIngresosNoValidados"
                        ]
                      }
                    </Box>
                  ) : null}
                </Box>
                {version === version[0] && (
                  <Box mt={5}>
                    <FormControl fullWidth>
                      <TextField
                        id="utilizacion-1"
                        label="Porcentaje utilización"
                        variant="outlined"
                        name="porcentajeUtilizacionIngresosNoValidados"
                        value={
                          ticketUpdate?.porcentajeUtilizacionIngresosNoValidados
                        }
                        onChange={handleUpdateTicket}
                      ></TextField>
                    </FormControl>
                  </Box>
                )}
                <Box mt={5}>
                  <FormControl fullWidth>
                    <TextField
                      id="score-1"
                      label="Score"
                      variant="outlined"
                      name="scoreIngresosNoValidados"
                      value={ticketUpdate?.scoreIngresosNoValidados}
                      error={
                        validation.tickets["scoreIngresosNoValidados"]
                          ? true
                          : false
                      }
                      onChange={handleUpdateTicket}
                      onBlur={validationValue}
                    ></TextField>
                  </FormControl>
                  {validation.tickets["scoreIngresosNoValidados"] ? (
                    <Box mt={2} sx={{ color: "red" }}>
                      {validation.tickets["creditosRealesIngresosNoValidados"]}
                    </Box>
                  ) : null}
                </Box>
                {version === "V2" && (
                  <Box mt={5}>
                    <FormControl fullWidth>
                      <TextField
                        id="score-minimo-pago-prami-ingresos-no-validados"
                        label="Score mínimo de pago Score Prami"
                        variant="outlined"
                        name="scoreMinimoPagarScorePramiIngresoNoValidado"
                        value={
                          ticketUpdate?.scoreMinimoPagarScorePramiIngresoNoValidado ??
                          ""
                        }
                        error={Boolean(
                          validation.tickets[
                            "scoreMinimoPagarScorePramiIngresoNoValidado"
                          ],
                        )}
                        helperText={
                          validation.tickets[
                            "scoreMinimoPagarScorePramiIngresoNoValidado"
                          ] || ""
                        }
                        inputProps={{ inputMode: "decimal" }}
                        onChange={handleUpdateTicket}
                        onBlur={handleFpdBlur}
                      ></TextField>
                    </FormControl>
                  </Box>
                )}
                <Box mt={5}>
                  <FormControl fullWidth>
                    {version === "V2" ? (
                      <TextField
                        id="score-minimo-pago-fpd-ingresos-no-validados"
                        label="Score mínimo de pago FPD"
                        variant="outlined"
                        name="scoreMinimoPagarFpdIngresoNoValidado"
                        value={
                          ticketUpdate?.scoreMinimoPagarFpdIngresoNoValidado ??
                          ""
                        }
                        error={Boolean(
                          validation.tickets[
                            "scoreMinimoPagarFpdIngresoNoValidado"
                          ],
                        )}
                        helperText={
                          validation.tickets[
                            "scoreMinimoPagarFpdIngresoNoValidado"
                          ] || ""
                        }
                        inputProps={{ inputMode: "decimal" }}
                        onChange={handleUpdateTicket}
                        onBlur={handleFpdBlur}
                      ></TextField>
                    ) : (
                      <TextField
                        id="score-fpd-ingresos-no-validados"
                        label="Score First Payment Default"
                        variant="outlined"
                        name="scoreMaximoFpdIngresoNoValidado"
                        value={
                          ticketUpdate?.scoreMaximoFpdIngresoNoValidado ?? ""
                        }
                        error={Boolean(
                          validation.tickets[
                            "scoreMaximoFpdIngresoNoValidado"
                          ],
                        )}
                        helperText={
                          validation.tickets[
                            "scoreMaximoFpdIngresoNoValidado"
                          ] || ""
                        }
                        inputProps={{ inputMode: "decimal" }}
                        onChange={handleUpdateTicket}
                        onBlur={handleFpdBlur}
                      ></TextField>
                    )}
                  </FormControl>
                </Box>
                <Box mt={5}>
                  <FormControl fullWidth>
                    <InputLabel id="tarifafga-ingresosNoValidados">
                      Tarifa Fondo Garantías
                    </InputLabel>
                    <Select
                      labelId="tarifafga-ingresosNoValidados"
                      id="tarifafgaingresosNoValidados-select"
                      label="Tarifa Fondo Garantías"
                      name="tarifafgaIngresosNoValidados"
                      value={ticketUpdate?.tarifafgaIngresosNoValidados}
                      onChange={handleUpdateTicket}
                    >
                      {tarifasfga.map((items) => (
                        <MenuItem key={items.name} value={items.value}>
                          {items.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  gap={"1rem"}
                  mt={5}
                >
                  <h3>Configuración Créditos</h3>
                  <ButtonPrincipal
                    sx={{ width: "fit-content", height: "fit-content" }}
                    onClick={() => handleSumValue("ingresos-no-validados")}
                  >
                    +
                  </ButtonPrincipal>
                </Box>
                <Box mb={5}>
                  {ticketUpdate?.valueStructuresNoValidados?.length > 1
                    ? ticketUpdate?.valueStructuresNoValidados?.map(
                        (items, index) => (
                          <FormGroup
                            key={items.id}
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "1rem",
                              justifyContent: "space-between",
                              border: "1px solid black",
                              padding: "1rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  name="creditosReales,ingresos-no-validados"
                                  checked={items.creditosReales}
                                  onChange={(event) =>
                                    handleChangeValue(event, index)
                                  }
                                ></Switch>
                              }
                              label="Reales"
                            />
                            <FormControlLabel
                              control={
                                <Switch
                                  name="creditosTelco,ingresos-no-validados"
                                  checked={items.creditosTelco}
                                  onChange={(event) =>
                                    handleChangeValue(event, index)
                                  }
                                ></Switch>
                              }
                              label="Telco"
                            />
                            <FormControlLabel
                              control={
                                <Switch
                                  name="creditosFinancieros,ingresos-no-validados"
                                  checked={items.creditosFinancieros}
                                  onChange={(event) =>
                                    handleChangeValue(event, index)
                                  }
                                ></Switch>
                              }
                              label="Financieros"
                            />
                            <ButtonPrincipal
                              sx={{
                                width: "fit-content",
                                height: "fit-content",
                                margin: "auto",
                              }}
                              onClick={() =>
                                handleDeleteValue(
                                  index,
                                  "ingresos-no-validados",
                                )
                              }
                            >
                              -
                            </ButtonPrincipal>
                          </FormGroup>
                        ),
                      )
                    : ticketUpdate?.valueStructuresNoValidados?.map(
                        (items, index) => (
                          <FormGroup
                            key={items.id}
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "1rem",
                              justifyContent: "space-between",
                              border: "1px solid black",
                              padding: "1rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  name="creditosReales,ingresos-no-validados"
                                  checked={items.creditosReales}
                                  onChange={(event) =>
                                    handleChangeValue(event, index)
                                  }
                                ></Switch>
                              }
                              label="Reales"
                            />
                            <FormControlLabel
                              control={
                                <Switch
                                  name="creditosTelco,ingresos-no-validados"
                                  checked={items.creditosTelco}
                                  onChange={(event) =>
                                    handleChangeValue(event, index)
                                  }
                                ></Switch>
                              }
                              label="Telco"
                            />
                            <FormControlLabel
                              control={
                                <Switch
                                  name="creditosFinancieros,ingresos-no-validados"
                                  checked={items.creditosFinancieros}
                                  onChange={(event) =>
                                    handleChangeValue(event, index)
                                  }
                                ></Switch>
                              }
                              label="Financieros"
                            />
                          </FormGroup>
                        ),
                      )}
                </Box>
                <h3>Ingresos validados</h3>
                <Box mt={5}>
                  <FormControl fullWidth>
                    <TextField
                      id="creditos-real-2"
                      label="Créditos reales"
                      variant="outlined"
                      name="creditosRealesIngresosValidados"
                      value={ticketUpdate?.creditosRealesIngresosValidados}
                      error={
                        validation.tickets["creditosRealesIngresosValidados"]
                          ? true
                          : false
                      }
                      onChange={handleUpdateTicket}
                      onBlur={validationValue}
                    ></TextField>
                  </FormControl>
                  {validation.tickets["creditosRealesIngresosValidados"] ? (
                    <Box mt={2} sx={{ color: "red" }}>
                      {validation.tickets["creditosRealesIngresosValidados"]}
                    </Box>
                  ) : null}
                </Box>
                <Box mt={5}>
                  <FormControl fullWidth>
                    <TextField
                      id="creditos-telco-2"
                      label="Créditos Telco"
                      variant="outlined"
                      name="creditosTelcoIngresosValidados"
                      value={ticketUpdate?.creditosTelcoIngresosValidados}
                      error={
                        validation.tickets["creditosTelcoIngresosValidados"]
                          ? true
                          : false
                      }
                      onChange={handleUpdateTicket}
                      onBlur={validationValue}
                    ></TextField>
                  </FormControl>
                  {validation.tickets["creditosTelcoIngresosValidados"] ? (
                    <Box mt={2} sx={{ color: "red" }}>
                      {validation.tickets["creditosTelcoIngresosValidados"]}
                    </Box>
                  ) : null}
                </Box>
                <Box mt={5}>
                  <FormControl fullWidth>
                    <TextField
                      id="creditos-financieros-2"
                      label="Créditos financieros cerrados"
                      variant="outlined"
                      name="creditosFinancierosIngresosValidados"
                      value={ticketUpdate?.creditosFinancierosIngresosValidados}
                      error={
                        validation.tickets[
                          "creditosFinancierosIngresosValidados"
                        ]
                          ? true
                          : false
                      }
                      onChange={handleUpdateTicket}
                      onBlur={validationValue}
                    ></TextField>
                  </FormControl>
                  {validation.tickets[
                    "creditosFinancierosIngresosValidados"
                  ] ? (
                    <Box mt={2} sx={{ color: "red" }}>
                      {
                        validation.tickets[
                          "creditosFinancierosIngresosValidados"
                        ]
                      }
                    </Box>
                  ) : null}
                </Box>
                {version === version[0] && (
                  <Box mt={5}>
                    <FormControl fullWidth>
                      <TextField
                        id="utilizacion-2"
                        label="Porcentaje utilización"
                        variant="outlined"
                        name="porcentajeUtilizacionIngresosValidados"
                        value={
                          ticketUpdate?.porcentajeUtilizacionIngresosValidados
                        }
                        onChange={handleUpdateTicket}
                      ></TextField>
                    </FormControl>
                  </Box>
                )}
                <Box mt={5}>
                  <FormControl fullWidth>
                    <TextField
                      id="score-2"
                      label="Score"
                      variant="outlined"
                      name="scoreIngresosValidados"
                      value={ticketUpdate?.scoreIngresosValidados}
                      error={
                        validation.tickets["scoreIngresosValidados"]
                          ? true
                          : false
                      }
                      onChange={handleUpdateTicket}
                      onBlur={validationValue}
                    ></TextField>
                  </FormControl>
                  {validation.tickets["scoreIngresosValidados"] ? (
                    <Box mt={2} sx={{ color: "red" }}>
                      {validation.tickets["scoreIngresosValidados"]}
                    </Box>
                  ) : null}
                </Box>
                {version === "V2" && (
                  <Box mt={5}>
                    <FormControl fullWidth>
                      <TextField
                        id="score-minimo-pago-prami-ingresos-validados"
                        label="Score mínimo de pago Score Prami"
                        variant="outlined"
                        name="scoreMinimoPagarScorePramiIngresoValidado"
                        value={
                          ticketUpdate?.scoreMinimoPagarScorePramiIngresoValidado ??
                          ""
                        }
                        error={Boolean(
                          validation.tickets[
                            "scoreMinimoPagarScorePramiIngresoValidado"
                          ],
                        )}
                        helperText={
                          validation.tickets[
                            "scoreMinimoPagarScorePramiIngresoValidado"
                          ] || ""
                        }
                        inputProps={{ inputMode: "decimal" }}
                        onChange={handleUpdateTicket}
                        onBlur={handleFpdBlur}
                      ></TextField>
                    </FormControl>
                  </Box>
                )}
                <Box mt={5}>
                  <FormControl fullWidth>
                    {version === "V2" ? (
                      <TextField
                        id="score-minimo-pago-fpd-ingresos-validados"
                        label="Score mínimo de pago FPD"
                        variant="outlined"
                        name="scoreMinimoPagarFpdIngresoValidado"
                        value={
                          ticketUpdate?.scoreMinimoPagarFpdIngresoValidado ?? ""
                        }
                        error={Boolean(
                          validation.tickets[
                            "scoreMinimoPagarFpdIngresoValidado"
                          ],
                        )}
                        helperText={
                          validation.tickets[
                            "scoreMinimoPagarFpdIngresoValidado"
                          ] || ""
                        }
                        inputProps={{ inputMode: "decimal" }}
                        onChange={handleUpdateTicket}
                        onBlur={handleFpdBlur}
                      ></TextField>
                    ) : (
                      <TextField
                        id="score-fpd-ingresos-validados"
                        label="Score First Payment Default"
                        variant="outlined"
                        name="scoreMaximoFpdIngresoValidado"
                        value={
                          ticketUpdate?.scoreMaximoFpdIngresoValidado ?? ""
                        }
                        error={Boolean(
                          validation.tickets["scoreMaximoFpdIngresoValidado"],
                        )}
                        helperText={
                          validation.tickets[
                            "scoreMaximoFpdIngresoValidado"
                          ] || ""
                        }
                        inputProps={{ inputMode: "decimal" }}
                        onChange={handleUpdateTicket}
                        onBlur={handleFpdBlur}
                      ></TextField>
                    )}
                  </FormControl>
                </Box>
                <Box mt={5}>
                  <FormControl fullWidth>
                    <InputLabel id="tarifafga-ingresosValidados">
                      Tarifa Fondo Garantías
                    </InputLabel>
                    <Select
                      labelId="tarifafga-ingresosValidados"
                      id="tarifafgaingresosValidados-select"
                      label="Tarifa Fondo Garantías"
                      name="tarifafgaIngresosValidados"
                      value={ticketUpdate?.tarifafgaIngresosValidados}
                      onChange={handleUpdateTicket}
                    >
                      {tarifasfga.map((items) => (
                        <MenuItem key={items.name} value={items.value}>
                          {items.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  gap={"1rem"}
                  mt={5}
                >
                  <h3>Configuración Créditos</h3>
                  <ButtonPrincipal
                    sx={{ width: "fit-content", height: "fit-content" }}
                    onClick={() => handleSumValue("ingresos-validados")}
                  >
                    +
                  </ButtonPrincipal>
                </Box>
                <Box mb={5}>
                  {ticketUpdate?.valueStructuresValidados?.length > 1
                    ? ticketUpdate?.valueStructuresValidados?.map(
                        (items, index) => (
                          <FormGroup
                            key={items.id}
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "1rem",
                              justifyContent: "space-between",
                              border: "1px solid black",
                              padding: "1rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  name="creditosReales,ingresos-validados"
                                  checked={items.creditosReales}
                                  onChange={(event) =>
                                    handleChangeValue(event, index)
                                  }
                                ></Switch>
                              }
                              label="Reales"
                            />
                            <FormControlLabel
                              control={
                                <Switch
                                  name="creditosTelco,ingresos-validados"
                                  checked={items.creditosTelco}
                                  onChange={(event) =>
                                    handleChangeValue(event, index)
                                  }
                                ></Switch>
                              }
                              label="Telco"
                            />
                            <FormControlLabel
                              control={
                                <Switch
                                  name="creditosFinancieros,ingresos-validados"
                                  checked={items.creditosFinancieros}
                                  onChange={(event) =>
                                    handleChangeValue(event, index)
                                  }
                                ></Switch>
                              }
                              label="Financieros"
                            />
                            <ButtonPrincipal
                              sx={{
                                width: "fit-content",
                                height: "fit-content",
                                margin: "auto",
                              }}
                              onClick={() =>
                                handleDeleteValue(index, "ingresos-validados")
                              }
                            >
                              -
                            </ButtonPrincipal>
                          </FormGroup>
                        ),
                      )
                    : ticketUpdate?.valueStructuresValidados?.map(
                        (items, index) => (
                          <FormGroup
                            key={items.id}
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "1rem",
                              justifyContent: "space-between",
                              border: "1px solid black",
                              padding: "1rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  name="creditosReales,ingresos-validados"
                                  checked={items.creditosReales}
                                  onChange={(event) =>
                                    handleChangeValue(event, index)
                                  }
                                ></Switch>
                              }
                              label="Reales"
                            />
                            <FormControlLabel
                              control={
                                <Switch
                                  name="creditosTelco,ingresos-validados"
                                  checked={items.creditosTelco}
                                  onChange={(event) =>
                                    handleChangeValue(event, index)
                                  }
                                ></Switch>
                              }
                              label="Telco"
                            />
                            <FormControlLabel
                              control={
                                <Switch
                                  name="creditosFinancieros,ingresos-validados"
                                  checked={items.creditosFinancieros}
                                  onChange={(event) =>
                                    handleChangeValue(event, index)
                                  }
                                ></Switch>
                              }
                              label="Financieros"
                            />
                          </FormGroup>
                        ),
                      )}
                </Box>
                <ButtonPrincipal
                  sx={{ marginTop: "1rem" }}
                  onClick={updateTicket}
                >
                  Guardar
                </ButtonPrincipal>
              </form>
            </Box>
          </Grid>
        </Modal>
      )}
      <Backdrop
        sx={{
          background: "rgba(255,255,255,0.1)",
          zIndex: "5",
          width: "50%",
          margin: "auto auto auto 30vw",
        }}
        open={backdrop}
      >
        <CircularProgress color="success" />
      </Backdrop>
      <Snackbar
        open={snackBar}
        autoHideDuration={5000}
        onClose={handleSnackbar}
      >
        <Alert
          onClose={handleSnackbar}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {alerta}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
}
